<template>
  <div>
    <download-excel
      style="display: inline-block"
      :fetch="startDownload"
      :fields="json_fields"
      type="xls"
      name="代币套餐订单图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="pic" slot-scope="text, record">
        <img :src="record" alt="" />
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />

      <template slot="operate" slot-scope="text, operate">
        <a
          href="javascript:;"
          @click="
            gotoDetails(
              `/home/tokenOrderTwo/tokenOrderDetailsTwo?orderNo=${operate.orderNo}`,
              operate.orderNo
            )
          "
          >订单详情</a
        >

        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import { tokenOrderList, tokenOrderListSeach } from "@/api/storeApi.js";

const columns = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    sorter: true,
    align: "center",
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "商品类型",
    dataIndex: "goodsPackage",
    align: "center",
    scopedSlots: { customRender: "goodsPackage" },
  },
  {
    title: "支付金额",
    dataIndex: "pricePay",
    align: "center",
    scopedSlots: { customRender: "pricePay" },
  },
  {
    title: "商品封面图片",
    dataIndex: "shopLogo",
    sorter: true,
    align: "center",
    scopedSlots: { customRender: "avatar" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    sorter: true,
    align: "center",
    scopedSlots: { customRender: "shopName" },
  },
  {
    title: "用户ID",
    dataIndex: "userUid",
    sorter: true,
    align: "center",
    scopedSlots: { customRender: "userUid" },
  },
  {
    title: "订单状态",
    dataIndex: "statusShopStr",
    sorter: true,
    width: "15%",
    align: "center",
    scopedSlots: { customRender: "statusShopStr" },
  },
  {
    title: "下单时间",
    dataIndex: "createTime",
    sorter: true,
    align: "center",
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    align: "center",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      img: [],
      json_fields: {
        订单编号: "orderNo",
        商品类型: "shopRunTypeStr",
        支付金额: "pricePay",
        商品封面: "avatar",
        所属门店: "shopName",
        用户ID: "userUid",
        订单状态: "statusShopStr",
        下单时间: "createTime",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      limit: 10,
      page: 1,
    };
  },
  mounted() {
    // this.fetch();
    this.getPackageListData();
  },
  props: ["formInline"],
  methods: {

    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
      const orderNo = this.formInline.orderNo;
       const userUid = this.formInline.userUid;
      const endDate = this.formInline.endDate;
      const startDate = this.formInline.startDate;
      
      // 第一步：获取总数量，判断数据规模
      const countRes = await tokenOrderListSeach(1, 1,orderNo, userUid,endDate, startDate);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        // 数据量较小，一次性获取
        const res = await tokenOrderListSeach(totalCount, 1, orderNo, userUid,endDate, startDate);
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const res = await tokenOrderListSeach(pageSize, page, orderNo, userUid,endDate, startDate);
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },

    topage(routerpath) {
      this.$router.push(routerpath);
    },
    aaa(row) {
      console.log(row);
    },
    hide() {},
    // 分页按钮数据
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      let that = this;

      // tokenOrderList(10, this.pagination.current, 654).then((res) => {
      //   that.data = res.data;
      //   that.loading = false;
      // });
      tokenOrderListSeach(
        this.formInline.limit,
        this.pagination.current,
        this.formInline.orderNo,
        this.formInline.userUid,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    getPackageListData() {
      tokenOrderList(10, 1, 654).then((res) => {
        this.pagination.total = res.count;
        this.img = res.data.goodsRecord;
        this.data = res.data;
        let arr = [];
        res.data.forEach((item) => {
          arr.push(JSON.parse(item.goodsRecord));
        });
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    // 查询
    query() {
      this.pagination.current = 1;
      this.loading = true;
      tokenOrderListSeach(
        this.formInline.limit,
        1,
        this.formInline.orderNo,
        this.formInline.userUid,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
      this.loading = false;
    },
    //详情
    gotoDetails(row) {
      console.log(row);
      this.$router.push(row);
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/tokenOrderTwo/tokenOrderContentTwo.vue